/**
 * Given an array of elements and a value, iterate over all elements and for
 * each element set the `textContent` to the given value.
 *
 * @param {Array<HTMLElement>} elems array of elements to be targeted
 * @param {String} value value to be set as textContent of all provided elements
 * @returns {void}
 */
export function setTextContent(elems, value) {
  elems.forEach((elem) => {
    elem.textContent = value;
  });
}

/**
 * Given an array of elements and a value, iterate over all elements and for
 * each element set the `value` to the given value.
 *
 * @param {Array<HTMLElement>} elems array of elements to be targeted
 * @param {String} value value to be set as textContent of all provided elements
 * @returns {void}
 */
export function setValue(elems, value) {
  elems.forEach((elem) => {
    elem.value = value;
  });
}
